export default function TheVision() {
  return (
    <section className="border-t border-[rgba(43,36,20,0.18)] px-6 py-24 sm:py-28">
      <div className="mx-auto max-w-2xl">
        <p
          className="text-[#7B7162] font-body"
          style={{
            fontWeight: 600,
            fontSize: 11,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
          }}
        >
          What this becomes
        </p>

        <h2
          className="mt-6 text-[#2B2414] font-display"
          style={{
            fontWeight: 400,
            fontSize: 'clamp(28px, 4vw, 40px)',
            lineHeight: 1.15,
            letterSpacing: '-0.022em',
          }}
        >
          A coach you barely think about.
        </h2>

        <div
          className="mt-10 flex flex-col gap-6 text-[#3D3526] font-body"
          style={{
            fontWeight: 400,
            fontSize: 17,
            lineHeight: 1.6,
            letterSpacing: '-0.011em',
          }}
        >
          <p>
            Most fitness apps have been scientifically engineered to be addicting, to keep you
            opening them. We're building the one you barely think about.
          </p>

          <p>
            A coach who remembers your training across decades. A 150-node skill tree sprawling
            across calisthenics, mobility, weightlifting, kettlebell training and more. A training
            plan that adapts — overloads and deloads, adjusts rest timer, weights, sets,
            exercises — specifically tailored to your circumstances: goals, current physique,
            available time, training style, available equipment. A physique analysis detailing
            EXACT strengths, weaknesses, and points of focus your coach adapts to.
          </p>

          <p>
            The relationship and detail a personal trainer would build with you across forty
            years — that's what we're building.
          </p>

          <p
            className="mt-6 text-[#2B2414]"
            style={{
              fontWeight: 500,
              letterSpacing: '-0.011em',
            }}
          >
            See you soon.
          </p>
        </div>
      </div>
    </section>
  );
}
